import React from 'react';
import { Button } from '@tonic/shared/components/ui';
import { Skeleton } from '@tonic/shared/components/ui';
import { Users, ShoppingCart, Settings, FileText, BarChart2, Package } from 'lucide-react';

const QUICK_LINKS = [
  {
    title: 'Users',
    icon: Users,
    href: '/admin/users'
  },
  {
    title: 'Orders',
    icon: ShoppingCart,
    href: '/admin/orders'
  },
  {
    title: 'Reports',
    icon: FileText,
    href: '/admin/reports'
  },
  {
    title: 'Analytics',
    icon: BarChart2,
    href: '/admin/analytics'
  },
  {
    title: 'Inventory',
    icon: Package,
    href: '/admin/inventory'
  },
  {
    title: 'Settings',
    icon: Settings,
    href: '/admin/settings'
  }
];

export function QuickLinks({ loading }) {
  if (loading) {
    return (
      <div className="flex gap-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-9" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-2 items-center">
      {QUICK_LINKS.map((link) => {
        const Icon = link.icon;
        return (
          <Button
            key={link.title}
            variant="ghost"
            size="icon"
            className="h-9 w-9"
            asChild
            title={link.title}
          >
            <a href={link.href}>
              <Icon className="h-4 w-4" />
              <span className="sr-only">{link.title}</span>
            </a>
          </Button>
        );
      })}
    </div>
  );
} 